<template>
    <a href="#main-content" class="skip-link" :inert="inert">Skip to main content</a>
</template>

<script setup lang="ts">
// Every layout that owns a `#main-content` region puts this first in the DOM, so the first Tab
// on a page jumps the rail and lands in the content.
//
// `inert` is the layout's drawer state. The mobile drawer declares itself `aria-modal` and traps
// Tab, but a trap only governs the keyboard: browse-mode navigation still walks the page behind
// it. Inert is what makes the modal claim true, and it has to cover this link as well. The link
// is a sibling of <main>, so inerting <main> alone leaves the link tabbable while the drawer
// covers the screen, pointing at a region that is itself inert.
defineProps<{
    inert?: boolean;
}>();
</script>

<style lang="scss" scoped>
.skip-link {
    @apply sr-only;

    &:focus {
        @apply not-sr-only fixed top-4 left-4 z-[200] px-4 py-2 rounded bg-white text-zinc-950;
    }
}
</style>
